import { render } from "./CollectionBlock.vue?vue&type=template&id=499cabc3&scoped=true"
import script from "./CollectionBlock.vue?vue&type=script&lang=js"
export * from "./CollectionBlock.vue?vue&type=script&lang=js"

import "./CollectionBlock.vue?vue&type=style&index=0&id=499cabc3&lang=less&scoped=true"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499cabc3"]])

export default __exports__